<template>
  <div class="contact container-half contact-content">
    <h1>Get in touch - we’re all ears.</h1>
    <div itemscope itemtype="http://schema.org/Organization" class="contact-info">
      <div class="telephone-email">
        <a href="mailto:info@auditlink.co.nz" class="email"><img src="../assets/mail.svg"><span itemprop="email">info@auditlink.co.nz</span></a>
        <a href="tel:+6463500450"  class="telephone"><img src="../assets/phone.svg" alt=""><span itemprop="telephone" content="+6463500450">Ph 06 350 0450</span></a>
      </div>
      <a href="https://goo.gl/maps/np9b9x2YCZm" target="_blank"><div class="address">
        <img src="../assets/pin.svg" alt="">
        <ul itemprop="address" itemscope itemtype="http://schema.org/PostalAddress">
          <li itemprop="streetAddress">196 Broadway Ave</li>
          <li itemprop="postOfficeBoxNumber">PO Box 648</li>
          <li><span itemprop="addressLocality">Palmerston North</span> <span itemprop="postalCode">4440</span></li>
        </ul>
      </div></a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',

  metaInfo () {
    return {
      title: 'Contact'
    }
  },

  mounted () {
    document.dispatchEvent(new Event('content-loaded'))
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Contact.vue